import { format } from "date-fns";

export default (date: Date) => {
  const currentDate = date;

  // First day of the current month
  const firstDayCurrentMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );

  // Last day of the next month
  const lastDayNextMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 2,
    0,
  );

  return {
    from: format(firstDayCurrentMonth, "yyyy-MM-dd"),
    to: format(lastDayNextMonth, "yyyy-MM-dd"),
  };
};
